import { useEffect, useRef } from 'react';

import { ELEMENTS_IDS } from 'shared/components/ApplicationLayout/constants/elements-ids';
import { HEADER_HEIGHT } from 'shared/constants/base-elements-sizes';

export function useGetHeaderHeight(): number {
  const headerRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    const header = document.getElementById(ELEMENTS_IDS.headerId);

    if (header) {
      headerRef.current = header;
    }
  }, []);

  return headerRef.current?.getBoundingClientRect().height || HEADER_HEIGHT;
}
